import { render } from "./PacManLoading.vue?vue&type=template&id=a13d257c&scoped=true"
const script = {}

import "./PacManLoading.vue?vue&type=style&index=0&id=a13d257c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13d257c"]])

export default __exports__